import SERVICE_URL, { LOG_TYPE } from "../config/API_DATA";
import { httpClient } from "./httpClient.js";
import main from "./../main";
import {Event} from "./../main.js"
import { COMPONENT_NAME} from "../util/constants.js";
import { addClassToBody } from "../util/util";
import Router from "../router/index";
import BaseConfiguration from "../config/base";
import Logger from "../services/logger";

export default class HttpUI {
  static count = 0;
  static isFareViewCalled = false;
    static async UIprocess() {
        try {

       
        //   Event.$on("component",(pcomponent) => {
        //     this.component = pcomponent;
        // });
          if(Event)
          Event.$on("isFareViewCalled",(isFareViewCalled) => {
            this.isFareViewCalled = isFareViewCalled;
        });
httpClient.interceptors.request.use((config) => {
  // for every request start the progress
  if(config.url!=SERVICE_URL.BALANCE_DETAIL&&config.url!=SERVICE_URL.LANGUAGE_LIST){
    if (main) main.$Progress.start();
    if(this.count>=0){
    this.count++;
    }else{
      this.count=0;
    }
  }
  if(BaseConfiguration.isAddApiLoadingClass){
  if(config.url== SERVICE_URL.CRS_FARE_VIEW && this.isFareViewCalled) {
    addClassToBody("Loading " +Router.currentRoute.name);
  }
    if(config.url!=SERVICE_URL.RENEW_JWT && config.url!=SERVICE_URL.GET_SEARCH_RESULT 
      && config.url!=SERVICE_URL.BALANCE_DETAIL&&config.url!=SERVICE_URL.LANGUAGE_LIST && 
      config.url!=SERVICE_URL.API_SEARCH_PASSENGER && config.url!=SERVICE_URL.CRS_FARE_VIEW){
      if(Router.currentRoute.name==COMPONENT_NAME.DEPOSIT ||Router.currentRoute.name==COMPONENT_NAME.VIEW_STATEMENTS) { ///temporary fixing
        addClassToBody("Loading " +COMPONENT_NAME.C_SYSTEM_DEPOSIT);
      }else{
        addClassToBody("Loading " +Router.currentRoute.name);
      }
      
   
    }
  }
  
    
  // if (config.url == SERVICE_URL.GET_PRICING_SEARCH) {
  //     addClassToBody(COMPONENT_NAME.FLIGHTRESULTS + " Loading");
  // } else if (config.url == SERVICE_URL.CREATE_BOOKING) {
  //   addClassToBody(COMPONENT_NAME.PAYMENTPAGE + " Loading");
  // } else if (config.url == SERVICE_URL.API_CREATE_PAYMENT_FOR_TICKETING) {
  //   addClassToBody(COMPONENT_NAME.TICKET_NOW + " Loading");
  // } else if (
  //   config.url == SERVICE_URL.UPDATE_PRICING ||
  //   config.url == SERVICE_URL.CREATE_PRICING
  // ) {
  //   addClassToBody(COMPONENT_NAME.CREATE_PRICING + " Loading");
  // }
  return config;
});

httpClient.interceptors.response.use((response) => {
  //  finish when a response is received
    if (main) 
    
    this.count--;
    if(this.count==0) {
       main.$Progress.finish();
       if(BaseConfiguration.isAddApiLoadingClass){

      if(Router.currentRoute.name==COMPONENT_NAME.DEPOSIT
         ||Router.currentRoute.name==COMPONENT_NAME.VIEW_STATEMENTS) { ///temporary fixing
        addClassToBody(COMPONENT_NAME.C_SYSTEM_DEPOSIT);
      }else{
        addClassToBody(Router.currentRoute.name);
      }
    }
    
    
    }
  return response;
});
        }
        catch (err) {
           
                    let body = Logger.buildRequest(
                        "HttpUI",
                        "UIprocess failed",
                        err.toString(),
                        "UIprocess",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                    }
    }
}
